import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=a79338fc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=a79338fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79338fc",
  null
  
)

export default component.exports